export default __webpack_public_path__ + "static/media/cover.f7bf13fd.jpg";